// Entra's password rule for a cloud account, which a tenant cannot configure
// (#336): 8 to 256 characters and at least 3 of the 4 kinds — a lowercase
// letter, an uppercase letter, a number (all ASCII), a symbol (any other
// character, a space included). The API applies the same rule with the same
// message (RuleBuilderExtension.Password). Entra stays the final authority: it
// also refuses banned and common passwords, which no rule here can predict,
// and the API answers such a refusal with a 400.
const MIN_LENGTH = 8;
const MAX_LENGTH = 256;
const KINDS = "a lowercase letter, an uppercase letter, a number, a symbol";
const KIND_PATTERNS = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/];

export const PASSWORD_POLICY_MESSAGE = `Password must be ${MIN_LENGTH} to ${MAX_LENGTH} characters and include at least 3 of: ${KINDS}.`;

// The same rule, shown under the field before anything is typed.
export const PASSWORD_POLICY_HINT = `${MIN_LENGTH} to ${MAX_LENGTH} characters, with at least 3 of: ${KINDS}.`;

// What the applicant is told when the API refuses a password without its own
// words for it. It names no reason because Entra's refusal does not say which
// of its rules the password broke.
export const PASSWORD_REFUSED_MESSAGE =
    "This password wasn't accepted. Choose a different one.";

export const meetsPasswordPolicy = (password: string): boolean => {
    if (password.length < MIN_LENGTH || password.length > MAX_LENGTH) {
        return false;
    }

    const kinds = KIND_PATTERNS.filter((kind) => kind.test(password)).length;

    return kinds >= 3;
};
